import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Logout } from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import { Store } from '@ngrx/store';
import { User } from '@vestiaire/api-sdk-angular';
import { environment } from '@env/environment';
import * as HeaderActions from '@app/core/header/store/actions/index';

@Component({
  selector: 'vc-profile-access',
  templateUrl: './profile-access.component.html',
  styleUrls: ['./profile-access.component.scss']
})
export class ProfileAccessComponent implements OnInit, OnChanges {
  public userIsLogged = false;
  @Input()
  userInfo: User;
  @Input()
  userWallet: any;
  @Input()
  needGetPaidAction: boolean;
  @Output()
  resetBox = new EventEmitter();

  walletAmount: string;
  imgixPath = environment.imgixPath;
  hyperWallet = environment.feature.hyperwallet;

  constructor(private store$: Store<IAppState>) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.userWallet) {
      this.userWallet.subscribe(
        res => {
          if (res) {
            if (res.balance && res.balance.formatted && res.balance.cents > 0) {
              this.walletAmount = res.balance.formatted;
            }
          }
        },
        () => {
          /* silently error */
        }
      );
    }
  }

  logout() {
    this.store$.dispatch(new Logout());
    this.store$.dispatch({
      type: HeaderActions.RESET_COUNTERS
    });
    this.resetBox.emit({
      value: true
    });
  }
}
